import React, { useState, useEffect } from 'react';
import OpenView from './components/OpenView';
import ClosedView from './components/ClosedView';

const CLOSES = new Date('2026-09-01T00:00:00+02:00');

function App() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    // Check the date every minute
    const timer = setInterval(() => {
      setNow(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  const isOpen = now < CLOSES;

  return (
    <div className="min-h-screen flex flex-col font-body">
      {isOpen ? <OpenView closesAt={CLOSES} now={now} /> : <ClosedView />}
    </div>
  );
}

export default App;